import { render, staticRenderFns } from "./SpecialAdCategories.ts.vue?vue&type=template&id=63234c60"
import script from "./SpecialAdCategories.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpecialAdCategories.ts.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports